export enum SystemStatus {
  Degraded,
  Maintenance,
  Operational,
  PartialOutage,
  TotalOutage,
}

const translation = {
  [SystemStatus.Degraded]: 'Degraded',
  [SystemStatus.Maintenance]: 'Maintenance',
  [SystemStatus.Operational]: 'Operational',
  [SystemStatus.PartialOutage]: 'Partial Outage',
  [SystemStatus.TotalOutage]: 'Total Outage',
};

const defaultCaption = {
  [SystemStatus.Degraded]: 'The service performance is decreasing, it is expected that the response time will increase.',
  [SystemStatus.Maintenance]: 'The service is currently down for maintenance, we expect to be back soon, please contact our CS team for more info.',
  [SystemStatus.Operational]: 'The service is running normally without issues.',
  [SystemStatus.PartialOutage]: 'There is an issue in response time and timeout in the service, we are currently investigating this problem, thank you for your patience.',
  [SystemStatus.TotalOutage]: 'There is a major issue which causes this service to be unusable for a while, please contact our CS for more info.',
};

const color = {
  [SystemStatus.Degraded]: 'yellow',
  [SystemStatus.Maintenance]: 'blue',
  [SystemStatus.Operational]: 'green',
  [SystemStatus.PartialOutage]: 'orange',
  [SystemStatus.TotalOutage]: 'red',
};

const severity = {
  [SystemStatus.Degraded]: 'warning',
  [SystemStatus.Maintenance]: 'warning',
  [SystemStatus.Operational]: 'success',
  [SystemStatus.PartialOutage]: 'warning',
  [SystemStatus.TotalOutage]: 'error',
};

export namespace SystemStatus {
  export function toString(status: SystemStatus): string {
    if (translation[status] === undefined) {
      throw Error(`System Status (${status}) is not defined!`);
    }
    return translation[status];
  }

  export function toEnum(status: string): SystemStatus {
    switch (status) {
      case translation[SystemStatus.Degraded]:
        return SystemStatus.Degraded;
      case translation[SystemStatus.Maintenance]:
        return SystemStatus.Maintenance;
      case translation[SystemStatus.Operational]:
        return SystemStatus.Operational;
      case translation[SystemStatus.PartialOutage]:
        return SystemStatus.PartialOutage;
      case translation[SystemStatus.TotalOutage]:
        return SystemStatus.TotalOutage;
      default:
        throw Error(`System Status (${status}) is not defined!`);
    }
  }

  export function toColor(status: SystemStatus): string {
    if (color[status] === undefined) {
      throw Error(`System Status (${status}) is not defined!`);
    }
    return color[status];
  }

  export function toSeverity(status: SystemStatus): 'error' | 'info' | 'success' | 'warning' {
    if (severity[status] === 'error') {
      return 'error';
    } else if (severity[status] === 'info') {
      return 'info';
    } else if (severity[status] === 'success') {
      return 'success';
    } else if (severity[status] === 'warning') {
      return 'warning';
    } else {
      throw Error(`System Status (${status}) is not defined!`);
    }
  }

  export function toDefaultCaption(status: SystemStatus): string {
    const result = defaultCaption[status];
    if (!result) {
      throw Error(`System Status (${status}) is not defined!`);
    }
    
    return result;
  }
}